<template>
  <div class="bulk-select-checkbox">
    <!-- Bulk Select -->
    <v-checkbox
      :ripple="false"
      hide-details
      :value="isSelectedAll"
      :indeterminate="isIndeterminate"
      :disabled="isDisabled"
      @click="handleOnChangeSelectAll"
    />
    <span class="selected-count" v-if="isBulk"> {{ $t("selected_with_count", { count: selectedCount }) }}</span>

    <div class="bulk-actions">
      <slot name="bulk-edit" v-if="isBulk" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  name: "AppFilterBulkSelect",

  props: {
    handleOnSelectAll: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters({
      filter: "App/filter",
    }),

    isBulk() {
      return this.selectedCount !== 0;
    },
  },

  data: () => ({
    selectedCount: 0,
    isSelectedAll: false,
    isIndeterminate: false,
    isDisabled: false,
  }),

  watch: {
    "filter.selectedItems": {
      immediate: true,
      deep: true,
      handler(selectedItems) {
        this.selectedCount = selectedItems.length;
        this.isSelectedAll = this.selectedCount === this.filter.items.length && !!this.filter.items.length;
        this.isIndeterminate = this.selectedCount !== this.filter.items.length && !!this.selectedCount;
        this.filter.isBulk = !!this.selectedCount;
        this.isDisabled = this.filter.items.length === 0;
      },
    },
  },

  methods: {
    /**
     * Handle on change the select all
     * @param e
     */
    handleOnChangeSelectAll(e) {
      e.preventDefault();
      this.handleOnSelectAll(!this.isSelectedAll);
    },
  },
});
</script>
